import { requestHelper } from "../helpers/request-helper";
import { useState } from "react";

export function useRescheduleOrder() {
  let [loadingRescheduleOrder, setLoadingRescheduleOrder] = useState(false);
  function rescheduleOrder({ orderId, address, period, type }) {
    setLoadingRescheduleOrder(true);
    let id = `or_${orderId}`;
    return requestHelper(
      `
          mutation reschedule($id: String!, $address: Int! , $period: Int! , $type: String!) {
            rescheduleOrder(
              order: $id
              address: $address
              period: $period
              type: $type
            ) {
              latest_status
            }
          }
        `,
      {
        id: id,
        address: address,
        period: period,
        type: type,
      }
    )
      .then((data) => {
        return data;
      })
      .finally(() => {
        setLoadingRescheduleOrder(false);
      });
  }

  return { rescheduleOrder, loadingRescheduleOrder };
}
